import { render, staticRenderFns } from "./Baccalaureat.vue?vue&type=template&id=3e5ff88d"
import script from "./Baccalaureat.vue?vue&type=script&lang=js"
export * from "./Baccalaureat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports